import { createStore, applyMiddleware, compose } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import reducer from "./reducers";

// ==============================|| REDUX - MAIN STORE ||============================== //

// Persist Config
const persistConfig = {
  key: "auth",
  storage,
  whitelist: ["auth"],
};

// Persisted Reducer
const persistedReducer = persistReducer(persistConfig, reducer);

export default function configureStore(initialState) {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools

  const store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk, reduxImmutableStateInvariant()))
  );

  const persistor = persistStore(store);

  return { store, persistor };
}
